export var ApplicableOrderTypes;

(function (ApplicableOrderTypes) {
  ApplicableOrderTypes["ALL"] = "ALL";
  ApplicableOrderTypes["DINEIN_ONLY"] = "DINEIN_ONLY";
  ApplicableOrderTypes["TOGO_ONLY"] = "TOGO_ONLY";
})(ApplicableOrderTypes || (ApplicableOrderTypes = {}));

export var IRenderingOption;

(function (IRenderingOption) {
  IRenderingOption["RADIO_BUTTON"] = "radioButton";
  IRenderingOption["CHECK_BOX"] = "checkbox";
  IRenderingOption["DROP_DOWN"] = "dropdown";
  IRenderingOption["TEMPERATURE_SLIDER"] = "slider";
})(IRenderingOption || (IRenderingOption = {}));